export default "__VITE_ASSET__D4kiK_LW__"